module.exports = __webpack_public_path__ + "img/P8-zh.f3f6ced5.png";